import { render } from "./CpltRoundLottie.vue?vue&type=template&id=15317762"
import script from "./CpltRoundLottie.vue?vue&type=script&lang=js"
export * from "./CpltRoundLottie.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__